import * as axios from "axios";
import apiConfig from "../config/apiConfig";
import constants from "../library/constants";

export default class ApiLog {

  constructor() {
   
    this.api_token = null;
    this.client = null;
    this.api_url = apiConfig.apiBaseUrl.logApi;
    this.api_key = apiConfig.apiBaseUrl.logApiID;
    
  }

  init = () => {
   
    // Was constants.storage.jwt, which is not a key on constants.storage, so
    // this resolved to getItem(undefined) === null and the Authorization
    // header below was never attached. Same bug as apiChat.js had.
    this.api_token = localStorage.getItem(constants.storage.accessToken);

    let headers = {
      'Accept': 'application/json',
      'x-api-key': this.api_key
    };

    if (this.api_token) {
      headers.Authorization = `Bearer ${this.api_token}`;
    }

    this.client = axios.create({
      baseURL: this.api_url,
      timeout: 31000,
      headers: headers,
    });

    return this.client;
  };
  
  // Lambda Function

  logsCreate = (data) => {
    return this.init().post("/ux_log",data);
  }

}
